import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { customBreakPointsProviders } from './breakpoints';
import { FlexAlignDirective } from './flex-align.directive';
import { FlexOffsetDirective } from './flex-offset.directive';
import { FlexOrderDirective } from './flex-order.directive';
import { FlexDirective } from './flex.directive';
import { LayoutAlignDirective } from './layout-align.directive';
import { LayoutHideDirective } from './layout-hide.directive';
import { LayoutShowDirective } from './layout-show.directive';
import { LayoutDirective } from './layout.directive';

@NgModule({
  imports: [CommonModule, FlexLayoutModule],
  declarations: [
    FlexAlignDirective,
    FlexOffsetDirective,
    FlexOrderDirective,
    FlexDirective,
    LayoutAlignDirective,
    LayoutDirective,
    LayoutHideDirective,
    LayoutShowDirective,
  ],
  exports: [
    FlexAlignDirective,
    FlexOffsetDirective,
    FlexOrderDirective,
    FlexDirective,
    LayoutAlignDirective,
    LayoutDirective,
    LayoutHideDirective,
    LayoutShowDirective,
  ],
  providers: [customBreakPointsProviders],
})
export class LayoutModule {}
